// +----------------------------------------------------------------------
// | 分类枚举 → 中文 / emoji 映射（数据库存英文，前端显示中文）
// +----------------------------------------------------------------------

export const CATEGORY_MAP = {
  life:          { label: '生活',    emoji: '🌿' },
  shopping:      { label: '购物',    emoji: '🛍️' },
  consumption:   { label: '消费',    emoji: '💳' },
  work:          { label: '工作',    emoji: '💼' },
  study:         { label: '学习',    emoji: '📚' },
  travel:        { label: '旅行',    emoji: '🧳' },
  relationship:  { label: '关系',    emoji: '💞' },
  social:        { label: '社交',    emoji: '👥' },
  entertainment: { label: '娱乐',    emoji: '🎬' },
  food:          { label: '吃喝',    emoji: '🍜' },
  time:          { label: '时间安排', emoji: '⏰' },
  other:         { label: '其他',    emoji: '🤔' },
};

export const COMPLEXITY_MAP = {
  simple:  { label: '简单',  desc: '直接给结论' },
  medium:  { label: '中等',  desc: '拆利弊 + 倾向' },
  complex: { label: '复杂',  desc: '需要先聊清楚' },
};

export const MODE_MAP = {
  normal: { label: '正常',     emoji: '💭', desc: '慢慢想清楚' },
  quick:  { label: '30 秒决定', emoji: '⚡', desc: '快速给倾向' },
  random: { label: '随便吧',   emoji: '🎲', desc: '图一乐，别太当真' },
};

export const STATUS_MAP = {
  pending:   { label: '进行中',  className: 'tag' },
  decided:   { label: '已决定',  className: 'tag' },
  undecided: { label: '还没定',  className: 'tag-plain' },
  cancelled: { label: '已取消',  className: 'tag-plain' },
};

export function categoryLabel(category) {
  const item = CATEGORY_MAP[category];
  return item ? `${item.emoji} ${item.label}` : category || '';
}

export function categoryText(category) {
  const item = CATEGORY_MAP[category];
  return item ? item.label : category || '';
}

export function categoryEmoji(category) {
  const item = CATEGORY_MAP[category];
  return item ? item.emoji : '🤔';
}

export function statusLabel(status) {
  const item = STATUS_MAP[status];
  return item ? item.label : status || '';
}

export function modeLabel(mode) {
  const item = MODE_MAP[mode];
  return item ? `${item.emoji} ${item.label}` : mode || '';
}
